const rules = {
	user: {
		static: [],
	},
	admin: {
		static: [
			'drawer-admin-items:view',
			'tickets-manager:showall',
			'user-modal:editProfile',
			'user-modal:editQueues',
			'ticket-options:deleteTicket',
			'ticket-options:transferWhatsapp',
			'contacts-page:deleteContact',
			'salefunnel-page:deleteFunnel'
		],
	},
	master: {
		static: [
			'master-area:view',
			'user-modal:editProfile',
			'ticket-options:transferWhatsapp',
			'ticket-options:deleteTicket',
		],
	},
};

export default rules;
